import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import { colors } from '@src/common/styles/valueTokens';

export const tableContainer = css({
  backgroundColor: theme.palette.surface.surfaceContainerLowest,
  borderRadius: theme.radius.around,
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: colors.border.primary,
  boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.1)',
  paddingTop: theme.spacing['5'],
});

export const tableStyle = css({
  backgroundColor: theme.palette.surface.surfaceContainerLowest,
  '&.MuiDataGrid-root': {
    borderRadius: theme.radius.bottom,
    borderWidth: '0px',
    borderTop: 'none',
  },
  '& .MuiDataGrid-container--top [role=row]': {
    backgroundColor: colors.tableHeader,
  },
  '& .MuiDataGrid-pinnedRows--top > :first-of-type': {
    backgroundColor: colors.secondary['90'],
    height: '40px',
    minHeight: '40px !important',
  },
  '& .MuiDataGrid-pinnedRows--top > :first-of-type .MuiDataGrid-cell': {
    height: '40px',
    alignItems: 'center',
    display: 'flex',
  },
  '& .MuiDataGrid-overlay': {
    backgroundColor: theme.palette.surface.surfaceContainerLowest,
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeader:focus': {
    outline: 'none',
  },
});
